<template>
  <div class="content">
    <Header></Header>
    <div class="main" v-show="this.isApp == true ? false : true">
      <MainLeft></MainLeft>
      <div class="main_content">
        <div class="navigation">{{ $t("nav.Homepage") }} >> {{ $t("vip.t8") }} >> {{ titleName }}</div>
        <div class="big_border">
          <div class="title-con">
            <div
              @click="changeTilte(item, index)"
              :class="cieTitle == index ? 'title-item-sub' : 'title-item'"
              v-for="(item, index) in vipList"
              :key="index"
            >
              <div>{{ item.title }}</div>
            </div>
          </div>
          <div class="smal_border">
            <div class="main-bord">
              <div class="pad-con">
                <div class="pad-title">{{ $t("vip.t2") }}</div>
                <div class="pad-ipt"><input type="password" v-model="oldPsd"></div>
              </div>
              <div class="pad-con">
                <div class="pad-title">{{ $t("vip.t3") }}</div>
                <div class="pad-ipt"><input type="password" v-model="newPsd"></div>
                <div class="pad-tip">{{ $t("vip.t4") }}</div>
              </div>
              <div class="pad-con">
                <div class="pad-title">{{ $t("vip.t5") }}</div>
                <div class="pad-ipt"><input type="password" v-model="cifPsd"></div>
                <div class="pad-tip-sub" v-show="isNo">{{ $t("vip.t9") }}</div>
              </div>
              <div class="pad-sub">
                <div class="pad-reset" @click="goReset">{{ $t("vip.t6") }}</div>
                <div class="pad-reset" @click="goSubmit">{{ $t("vip.t7") }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="main-h5" v-show="this.isApp == false ? false : true">
      <div class="main_content-h5">
        <div class="navigation">{{ $t("nav.Homepage") }} >> {{ $t("vip.t8") }} >> {{ $t("vip.t1") }}</div>
        <div class="big_border">
          <div class="title-con">
            <div
              @click="changeTilte(item, index)"
              :class="cieTitle == index ? 'title-item-sub' : 'title-item'"
              v-for="(item, index) in vipList"
              :key="index"
            >
              <div>{{ item.title }}</div>
            </div>
          </div>
          <div class="smal_border">
            <div class="main-bord">
              <div class="pad-con">
                <div class="pad-title">{{ $t("vip.t2") }}</div>
                <div class="pad-ipt-h5"><input type="password" v-model="oldPsd"></div>
              </div>
              <div class="pad-con">
                <div class="pad-title">{{ $t("vip.t3") }}</div>
                <div class="pad-ipt-h5"><input type="password" v-model="newPsd"></div>
                <div class="pad-tip">{{ $t("vip.t4") }}</div>
              </div>
              <div class="pad-con">
                <div class="pad-title">{{ $t("vip.t5") }}</div>
                <div class="pad-ipt-h5"><input type="password" v-model="cifPsd"></div>
                <div class="pad-tip-sub" v-show="isNo">{{ $t("vip.t9") }}</div>
              </div>
              <div class="pad-sub">
                <div class="pad-reset" @click="goReset">{{ $t("vip.t6") }}</div>
                <div class="pad-reset" @click="goSubmit">{{ $t("vip.t7") }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Login-pop ref="LoginPop"></Login-pop>
    <Footer></Footer>
    <My-popup 
				:popupMsg = "popupMsg" 
				@handlePopup='handleShowOrHidePopup'
				v-show="showPopup"/>
    <router-view />
  </div>
</template>
<script>
import { mapActions, mapState, mapMutations } from "vuex";

export default {
  data() {
    return {
      titleName:'',
      cieTitle:0,
      oldPsd:'',
      newPsd:'',
      cifPsd:'',
      isNo:false,
      showPopup:false,
      popupMsg:{
									title:'',
									content:'',
									// cancel:'取消',
									confirm:'ok'
			},
    };
  },
   computed: {
    ...mapState({
      hasLogin(state) {
        return state.hasLogin;
      },
      isApp(state) {
        return state.isApp;
      },
      tokenData(state){
        return state.tokenData;
      }
    }),
    vipList(){
      return [
        {
          title:this.$t("vip.t1")
        }
      ]
    }
  },
  created() {
    // console.log('window.location.pathname',window.location.href)
    var str = "window.location.href";
    // console.log(str.indexOf("vip") != -1 );  // true
  },
  mounted(){
    this.titleName = this.vipList[0].title
  },
  methods: {
    goReset(){
      this.oldPsd=''
      this.newPsd=''
      this.cifPsd=''
    },
    goSubmit(){
      if(this.newPsd!=this.cifPsd){
        this.isNo = true
      }
      if(this.newPsd==this.cifPsd){
        this.isNo = false
        this.modifyPasswd()
      }
    },
    modifyPasswd(){
      // console.log('tokenData',this.tokenData)
        var _that = this;
        let obj = {
        new_password:_that.newPsd,
        old_password:_that.oldPsd,
        token:_that.tokenData,
      };
      this.$FucPost(this.$store.state.ip + "/modifyPasswd", obj)
        .then(function (res) {
          // console.log("modifyPasswd-res", res);
          if(res.code!=200){
            _that.showPopup=true
            _that.popupMsg.content = res.msg
          }
          if(res.code==200){
            _that.showPopup=true
            _that.popupMsg.content = res.msg
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changeTilte(e, index) {
      this.titleName = e.title
      this.cieTitle = index;
      
    },
    handleShowOrHidePopup:function(type){
							if(type=='yes'){
								// console.log(type)
								this.showPopup = false
                // location.reload();
							}else{
								// console.log(type)
								this.showPopup = false
                // location.reload();
							}
						},
  },
};
</script>
<style lang="less" scoped="">
.main_content {
  color: #000000;
  width: 75%;
  float: right;
}
.main_content-h5 {
  color: #000000;
  
}
.big_border{
    padding: 0.625rem 0;
    background-color: #bc981e;
    width: 100%;
    border-radius: 0.625rem;
}
.big_border-h5{
    padding: 0.625rem 0;
    background-color: #bc981e;
    width: 23.4375rem;
    border-radius: 0.625rem;
}
.smal_border{
  background-color: #d7ceb0;
    width: 98%;
    margin: 0 auto;
    // border-radius: 10px;
    border-bottom-left-radius: 0.625rem;
    border-bottom-right-radius: 0.625rem;

}
.main-bord{
  padding: 1.25rem;
}
.pad-con{
  margin-bottom: 1.25rem;
  font-size: 1rem;
  text-align: left;
}
input{
  width: 100%;
  padding: 0.3125rem;
  border-radius: 0.3125rem;
}
.pad-ipt{
  width: 60%;
  margin: 0.625rem 0;
}
.pad-ipt-h5{
  width: 18.75rem;
  margin: 0.625rem 0;
}
.pad-tip{
  font-size: 0.875rem;
}
.pad-sub{
  display: flex;
  align-items: center;
  justify-content: right;
  margin-top: 6.25rem;
}
.pad-reset{
    border-radius: 0.25rem;
    font-size: 0.9375rem;
    font-weight: bold;
    padding: 0.625rem 0.9375rem;
    margin-right: 1.25rem;
    border: none;
    background: linear-gradient(45deg, #ce9211, #d3b679, #ce9211);
    cursor: pointer;
}
.pad-reset:hover{
    border-radius: 0.25rem;
    font-size: 0.9375rem;
    font-weight: bold;
    padding: 0.625rem 0.9375rem;
    margin-right: 1.25rem;
    border: none;
    background: linear-gradient(45deg, #d3b679, #e9a208, #d3b679);
    cursor: pointer;
}
.pad-tip-sub{
  color: red;
  font-size: 0.875rem;
}
.navigation-h5{
  width: 23.4375rem;
}
.title-con {
  width: 98%;
  margin: 0 auto;
  border-top-right-radius: 0.5rem;
  border-top-left-radius: 0.5rem;
  display: flex;
  align-items: center;
  background: linear-gradient(
    #7d1f00,
    #912e04,
    #9b2e03,
    #671c00,
    #330b03
  ) !important;
  border-top: solid 0.125rem #902d03;
  border-bottom: solid 0.125rem #5c1e09;
  height: 2.5rem;
}
.title-item {
  cursor: pointer;
  height: 2.5rem;
  line-height: 2.5rem;
  min-width: 6.25rem;
  padding: 0 0.625rem;
  text-align: center;
}
.title-item-sub {
  cursor: pointer;
  text-align: center;
  min-width: 6.25rem;
  color: rgb(236, 197, 22);
  padding: 0 0.625rem;
  height: 2.5rem;
  line-height: 2.5rem;
  background: linear-gradient(
    #7d1f00,
    #2e1004,
    #250c03,
    #2e1004,
    #330b03
  ) !important;
  border-top: solid 0.125rem #902d03;
  border-bottom: solid 0.125rem #5c1e09;
}
</style>
